// \src\pages\home\components\AllProductsBanner.tsx

import { Link } from "react-router-dom";
import { useAdmin } from "@/context/AdminContext";

function isVideoMedia(src: string): boolean {
  return /\.(mp4|webm)(?:[?#].*)?$/i.test(String(src || ""));
}

export default function AllProductsBanner() {
  const { data } = useAdmin();
  const media = data.settings.allProductsBannerMedia || "/images/banners/05.jpg";

  return (
    <section className="w-full relative overflow-hidden">
      <div className="relative h-[240px] md:h-[300px]">
        {isVideoMedia(media) ? (
          <video
            src={media}
            className="w-full h-full object-cover object-top"
            autoPlay
            muted
            loop
            playsInline
            preload="metadata"
            aria-label="Todos os nossos produtos"
          />
        ) : (
          <img
            src={media}
            alt="Todos os nossos produtos"
            className="w-full h-full object-cover object-top"
          />
        )}

        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-black/30" />

        <div className="absolute inset-0 flex flex-col items-center justify-center px-4 text-center">
          <span className="text-primary-400 font-label text-sm font-semibold uppercase tracking-widest mb-3">
            Catálogo completo
          </span>

          <h2 className="text-3xl md:text-5xl font-heading font-bold text-background-50 mb-4">
            TODOS OS NOSSOS PRODUTOS
          </h2>

          <p className="text-background-300 text-base max-w-lg mb-6">
            Explore nosso catálogo completo com materiais de qualidade para toda sua obra
          </p>

          <Link
            to="/produtos"
            className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-10 py-3 rounded-md font-label font-bold text-base transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-store-2-line" />
            Explorar Catálogo
          </Link>
        </div>
      </div>
    </section>
  );
}